import React, { FC } from 'react';
import { cx } from '@emotion/css';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';

const RATING_VALUES = [0, 1];
const getThumbsIconByRating = (like: boolean) => getDesignSystemIcon(`icon-thumbs-${like ? 'up' : 'down'}-16.svg`);

export const FeedbackThumbsRating: FC<
  React.PropsWithChildren<{
    ratingValue?: number;
    onClickRating: (ratingValue: number) => void;
    className?: string;
    feedbackLabels?: [string, string];
  }>
> = ({ ratingValue = null, onClickRating, className, feedbackLabels }) => (
  <div className={cx('', className)}>
    <div className="flex justify-center">
      {(RATING_VALUES as [0, 1]).map((value) => (
        <div key={value} className="mr-12 flex flex-col items-center gap-2 last:mr-0">
          <svg
            onClick={() => onClickRating(value)}
            data-testid={`feedbackPanelThumb${value ? 'Up' : 'Down'}`}
            className={cx(
              'h-8 w-8 transform-gpu cursor-pointer transition-colors duration-500 hover:text-secondary-dark',
              ratingValue === value ? 'text-primary-orange' : 'text-secondary'
            )}
          >
            <PhoenixIcon icon={getThumbsIconByRating(!!value)} />
          </svg>
          {feedbackLabels && <span className="stihl-text-body-sm-reg tablet:stihl-text-body-default-reg">{feedbackLabels[value]}</span>}
        </div>
      ))}
    </div>
  </div>
);
